import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { FieldValidator } from '@app/core/model/other/field-validator';
import {
  TextFieldBuilderComponent
} from '@app/shared/components/fields/text-field-builder/text-field-builder.component';

@Component({
    selector: 'email-field-builder',
    templateUrl: './email-field-builder.component.html',
    styleUrls: ['./email-field-builder.component.scss'],
    standalone: false
})
export class EmailFieldBuilderComponent extends TextFieldBuilderComponent implements OnInit, AfterViewInit {
  /**
   * Validators that are default to the field type
   * @private
   */
  private defaultValidators = [
    new FieldValidator(ValidatorType.EMAIL)
  ];

  /**
   * Get a validator function which combines all validators from the field's config.
   * @param data Additional data that can be passed to composing validators when required.
   * @returns Composed validator function.
   */
  protected override computeValidators(data?: { [key: string]: any }): ValidatorFn {
    return Validators.compose([
      ...this.defaultValidators.map(validator => this.validationService.getValidator(validator)),
      ...(this.fieldConfig.field?.validators.map((validator) => {
        return this.validationService.getValidator(validator, this.entity, data);
      }) ?? [])
    ]);
  }

  /**
   * List of validators for which an error has been raised by the corresponding validator function.
   */
  public override get erroredValidators(): FieldValidator[] {
    return [...this.fieldConfig.field.validators, ...this.defaultValidators]
      .filter((validator) => !!this.form.controls.field.errors?.[validator.code]);
  }

  /**
   * Prevent entering in edition mode when clicking on the mailto link.
   * @param event
   */
  public onMailTo(event: MouseEvent): void {
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
}
